// extracted by mini-css-extract-plugin
module.exports = {"centerChildren":"Logout-Logout-centerChildren-2b72e7fe","successMessage":"Logout-Logout-successMessage-81f01797"};